import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareI = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler9') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler9', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Rev wep!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Rev wep!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareI}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareI
  
